module.exports = __webpack_public_path__ + "static/media/Helius PFA.7df933b8.png";